<template>
  <!-- 财税实战课堂 V0.3 原型（教师端）· 结构与样式 100% 按交互原型 index.html -->
  <div
    id="tax-classroom-v3"
    aria-label="财税实战课堂产品原型"
    v-loading="loading"
  >
    <div class="cl-app">
      <header id="cl-common-head" class="cl-head">
        <div class="cl-brand">
          <span class="rh-logo-plate"
            ><img
              :src="RH_LOGO"
              alt="仁和会计 RENHE ACCOUNTANCY"
              width="780"
              height="180"
          /></span>
          <div>
            <strong>财税实战课堂</strong>
            <small>一起把真实问题带进课堂</small>
          </div>
        </div>
        <nav class="cl-nav" aria-label="课程导航">
          <button
            v-for="item in navItems"
            :key="item.id"
            type="button"
            :class="{ current: item.id === activePage }"
            @click="go(item)"
          >
            {{ item.label }}
          </button>
        </nav>
        <div class="cl-user">
          <!-- <span class="cl-badge">原型示意 · 全部为示例数据</span> -->
          <span id="cl-user-name">
            <span>{{ userStore.userInfo.displayName }}</span>
            <template v-for="(item, index) in roleArr" :key="index">
              ·
              <span>{{ item }}</span>
            </template></span
          >
        </div>
      </header>
      <div id="cl-common-context" class="cl-context">
        <div>
          <strong style="margin-right: 10px">
            {{ classData.subjectName }}
          </strong>
          <span class="cl-muted">
            {{ classData.className }} · 第 {{ classData.courseNo }} 讲
            {{ classData.courseName }}
          </span>
        </div>
        <span
          id="cl-window-label"
          class="cl-tag"
          v-if="classData.interactStatus != null"
          >{{
            classData.interactStatus == 1
              ? "课堂互动开放中 · 本班可见"
              : "课堂已结束 · 学员只读"
          }}</span
        >
      </div>
      <router-view
        v-if="practicalClassQuery.classId && classData.id"
        :practicalClassQuery="practicalClassQuery"
        :classData="classData"
      />
      <div
        id="cl-toast"
        class="cl-toast"
        role="status"
        aria-live="polite"
        :hidden="!toastState.visible"
      >
        {{ toastState.text }}
      </div>
    </div>
  </div>
</template>

<script setup>
import "./taxClassroom.scss";
import RH_LOGO from './imgs/logo.png'
import { st, toastState, hideToast, ROUTE_PAGES } from "./store";
import useUserStore from "@/store/modules/user";
import { demandClassConfigQuery } from "@/api/practicalClass";
import { $emit, $on } from "vue-happy-bus";

const userStore = useUserStore();
const roleArr = computed(() => {
  let arr = [];
  if (userStore.userInfo.roles && userStore.userInfo.roles.length > 0) {
    userStore.userInfo.roles.forEach((item) => {
      arr.push(item.roleName);
    });
  }
  return arr;
});

// 教师端菜单（对应原型教师角色导航）
const navItems = [
  { id: "teacher", label: "真实需求", path: "/practicalClass/real-needs" },
  {
    id: "builder",
    label: "出题与发布",
    path: "/practicalClass/question-publish",
  },
  { id: "grading", label: "作业批阅", path: "/practicalClass/homework-review" },
  {
    id: "resources",
    label: "课程资料",
    path: "/practicalClass/course-materials",
  },
  { id: "sync", label: "学员成绩", path: "/practicalClass/crm-sync" },
];

const route = useRoute();
const router = useRouter();
// 与原型一致：问题放大页、需求管理页导航高亮「真实需求」，问题墙不高亮
const activePage = computed(
  () =>
    (route.path === ROUTE_PAGES.detail || route.path === ROUTE_PAGES.needs
      ? "teacher"
      : ROUTE_PAGES[route.path]) || "",
);

function go(item) {
  if (route.path !== item.path) router.push(item.path);
}

// 与原型一致：切换页面时隐藏 toast
watch(
  () => route.path,
  () => hideToast(),
);

const practicalClassQuery = ref({});

// ===== 原有逻辑：storage 没值且 URL 有参数时写入 =====
if (
  !sessionStorage.getItem("practicalClassQuery") &&
  Object.keys(route.query).length > 0
) {
  sessionStorage.setItem("practicalClassQuery", JSON.stringify(route.query));
}

// ===== 新增：URL 有 classId & courseNo 才对比和覆盖 =====
const stored = JSON.parse(sessionStorage.getItem("practicalClassQuery") || "{}");
const current = route.query;

if (current.classId && current.courseNo) {
  if (
    current.classId != stored.classId ||
    current.courseNo != stored.courseNo
  ) {
    sessionStorage.setItem(
      "practicalClassQuery",
      JSON.stringify({
        classId: current.classId,
        courseNo: current.courseNo,
      })
    );
  }
}

// ===== 最终取值（原有，不动）=====
practicalClassQuery.value = JSON.parse(
  sessionStorage.getItem("practicalClassQuery") || "{}",
);

initViewPort();

function initViewPort() {
  const metaViewport = document.createElement("meta");
  metaViewport.name = "viewport";
  metaViewport.content =
    "width=device-width, initial-scale=1.0, maximum-scale=1, viewport-fit=cover";
  document.head.appendChild(metaViewport);
}

const classData = ref({
  interactStatus: null, // 1:开启 0:关闭
});
const loading = ref(false);
async function init() {
  try {
    loading.value = true;
    const { classId, courseNo } = practicalClassQuery.value;

    const demandClassConfigQueryRes = await demandClassConfigQuery({
      classId,
      courseNo,
    });
    classData.value = demandClassConfigQueryRes.data || {};

    loading.value = false;
  } catch (error) {
    console.error(error);
  } finally {
    // loading.value = false;
  }
}

$on("practicalClassIndexInit", () => init());

onMounted(() => {
  init();
});
</script>
<style lang="scss" scoped>
#tax-classroom-v3 .rh-logo-plate{
  background-color: transparent;
}
</style>
